// extracted by mini-css-extract-plugin
export default {"cancelModalContent":"style_cancelModalContent__nyG2O","cancelModalButtons":"style_cancelModalButtons__zboSv"};